'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'receipt';
var width = 384;
var height = 512;
var aliases = [129534];
var unicode = 'f543';
var svgPathData = 'M32.4 1.5C25.1-1.2 16.8-.2 10.3 4.3S0 16.1 0 24L0 488c0 7.9 3.9 15.2 10.3 19.7s14.7 5.5 22.1 2.7l55-20.6 47.1 20.2c6.5 2.8 13.9 2.6 20.2-.6l37.3-18.6 37.3 18.6c6.3 3.2 13.7 3.4 20.2 .6l47.1-20.2 55 20.6c7.4 2.8 15.6 1.7 22.1-2.7S384 495.9 384 488l0-464c0-7.9-3.9-15.2-10.3-19.7s-14.7-5.5-22.1-2.7l-55 20.6-47.1-20.2C243-.8 235.6-.6 229.3 2.5L192 21.2 154.7 2.5C148.4-.6 141-.8 134.5 1.9L87.4 22.1 32.4 1.5zM48 453.4L48 58.6 79.6 70.5c5.8 2.2 12.2 2 17.9-.4l45.8-19.6 38 19c6.8 3.4 14.7 3.4 21.5 0l38-19 45.8 19.6c5.7 2.4 12.1 2.6 17.9 .4l31.6-11.8 0 394.7-31.6-11.8c-5.8-2.2-12.2-2-17.9 .4l-45.8 19.6-38-19c-6.8-3.4-14.7-3.4-21.5 0l-38 19-45.8-19.6c-5.7-2.4-12.1-2.6-17.9-.4L48 453.4zM120 136c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zM96 256c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faReceipt = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;